import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { parseMediaDimensionValue, selectCreativesAuthLoaded, useRequestCreative } from '@/entities/creatives';
import { useAppSelector } from '@/shared/model';
import { TooltipListItem } from '../TooltipListItem/TooltipListItem';

const Image = styled('img')(() => ({
  height: 16,
  width: 16,
  aspectRatio: '1 / 1',
  objectFit: 'contain',
}));

interface Props {
  pattern?: string;
  nameObject: string;
  value: number;
  color: string;
  valueFormatter: (v: number) => string;
}

export function TooltipMediaItem({
  pattern,
  color,
  nameObject,
  value,
  valueFormatter,
}: Props) {
  const parsed = parseMediaDimensionValue(nameObject);
  const creative = useRequestCreative(parsed);
  const isAuthLoaded = useAppSelector(selectCreativesAuthLoaded);
  const label = creative?.adName ?? parsed?.ad_name ?? nameObject;
  const url = isAuthLoaded ? (creative?.thumbnailUrl ?? '') : '';

  return (
    <TooltipListItem
      label={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ color }}>
            {pattern}{url ? <> <Image src={url} /></> : null} {label}
          </span>
          :
        </Box>
      }
      value={valueFormatter(value)}
    />
  );
}
